import { FunctionComponent, useEffect, useState } from "react";
import {
  useToast,
  ToastType,
} from "../../../../context_providers/toast/toast_ctx";
import { GetInventoryListApi } from "../../../../service/repos/inventory_repo";
import { debounce } from "../../../../utils/debounce";
import AutoCompleteField from "../../../new_components/common/autocomplete";
import { uniqueId } from "lodash";
import { GetAvailableDevicesAPI } from "../../../../service/repos/order_repo";
import { AvailableDevices } from "../../../../erp/inventory/models/inventory_voucher";

interface InventoryDropDownProps {
  onSelect: (val: { device_id: string; name: string }) => void;
  selected: { device_id: string; name: string }[];
  disabled?: boolean;
  status?: string[];
  product_id: string; // item_code
  old_name?: string;
}

const InventoryDropDownV2: FunctionComponent<InventoryDropDownProps> = ({
  selected,
  onSelect,
  disabled = false,
  status,
  product_id,
  old_name,
}) => {
  const { showToast } = useToast();
  const [selectedDeviceIds, setSelectedDeviceIds] = useState<
    { device_id: string; name: string }[]
  >([]);
  const [loading, setLoading] = useState(false);
  // const [inventories, setInventories] = useState<InventoryModel[]>([]);
  const [inventories, setInventories] = useState<AvailableDevices[]>([]);
  const [search, setSearch] = useState<string>("");
  const searchInventory = async (search: string) => {
    setLoading(true);

    const res = await GetAvailableDevicesAPI({
      unique_id: search,
      item_code: product_id,
      old_name: old_name,
    });

    if (res.success) {
      setInventories(res.data);
    } else {
      setInventories([]);
      showToast({ type: ToastType.error, text: res.error ?? "" });
    }
    setLoading(false);
  };
  useEffect(() => {
    if (search) {
      debounce(() => searchInventory(search));
    } else setInventories([]);
  }, [search]);
  useEffect(() => {
    setSelectedDeviceIds(selected);
  }, [selected]);
  return (
    <>
      <div className="flex gap-1 flex-col items-start flex-wrap">
        <label htmlFor="device">Devices ({selectedDeviceIds.length})</label>
        <AutoCompleteField
          disabled={disabled}
          loading={loading}
          value={search}
          placeholder={"Device"}
          onSelect={(selected_value) => {
            const device = selected_value.value;
            console.log("Device", device);
            if (
              !device.device_id &&
              (!device.uniqueIds || !device.item?.name)
            ) {
              showToast({
                type: ToastType.error,
                text: "Invalid device selected",
              });
              return;
            }

            // Use device_id if it exists, else fallback to uniqueIds
            const idToCompare = device.device_id
              ? device.device_id
              : device.uniqueIds;

            const notContain = selectedDeviceIds.every(
              (v) => v.device_id !== idToCompare
            );

            if (notContain) {
              const newSelection = {
                device_id: idToCompare,
                name: device.item?.name ?? "",
              };

              onSelect(newSelection);
              setSelectedDeviceIds((prev) => [...prev, newSelection]);
              setSearch("");
            } else {
              showToast({
                type: ToastType.warning,
                text: `${idToCompare} already selected`,
              });
            }
          }}
          suggestions={inventories.map((e) => {
            const displayId = e.device_id ? e.device_id : e.uniqueIds;
            return {
              label: (
                <div className="text-xs">
                  <b>
                    {displayId} - {e.item?.item_code}
                  </b>{" "}
                  <span style={{ fontSize: "10px" }}>({e.item?.name})</span>
                </div>
              ),
              value: e,
            };
          })}
          // suggestions={inventories.map((e) => ({
          //   label: (
          //     <div className="text-xs">
          //       <b>
          //         {e.uniqueIds} - {e.item?.item_code}{" "}
          //       </b>
          //       <span style={{ fontSize: "10px" }}>({e.item?.name})</span>
          //     </div>
          //   ),

          //   value: e,
          // }))}
          onChange={(str) => {
            setSearch(str);
          }}
        />
        <p className="text-xs text-blue-400">
          note : Please select device id from suggestions .
        </p>
      </div>
    </>
  );
};

export default InventoryDropDownV2;
